/**
 * Idle-time chunk prefetch for HotelBookingModal (which dynamic-imports HotelBookingClientPage +
 * Stripe internally), mirroring form-prefetch.ts's pattern for form links. Warms the JS chunk only —
 * separate from data prefetching, since the embed bundle needs a specific booking link id the
 * button/link doesn't resolve until click.
 */

import { HOTEL_BOOKING_MODAL_PREFETCH_IDLE_TIMEOUT_MS } from "./constants";
import { runOnIdle } from "./utils/run-on-idle";

let warmed = false;

/**
 * Idle-deferred prefetch of the HotelBookingModal chunk. Safe to call multiple times; only the
 * first call triggers the import. No-op on the server.
 */
export function prefetchHotelBookingModal(): void {
  if (typeof window === "undefined") return;
  if (warmed) return;
  warmed = true;

  runOnIdle(() => {
    import("../_components/public/HotelBookingModal").catch((err) => {
      console.error("prefetchHotelBookingModal: error", err);
    });
  }, HOTEL_BOOKING_MODAL_PREFETCH_IDLE_TIMEOUT_MS);
}
